import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "../config/config";
import { AddNewModuleComponent } from "../components/workflow-configuration/add-new-module/add-new-module.component";
import { Observable } from "rxjs";
import { AddNewUtilityModel } from "../models/module.model";

@Injectable({
    providedIn: 'root',
})
export class ModuleService {
    private pathApi: string;
    constructor(private http: HttpClient, private config: AppConfig) {
        this.pathApi = this.config.setting['pathApi'] + 'Module/';
    }

    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    addNewModule(obj: AddNewUtilityModel): Observable<any> {
        const formData = new FormData();
        formData.append('name', obj.name.toString());
        formData.append('description', obj.description.toString());
        formData.append('color', obj.color);
        if (obj.moduleImage != null)
            formData.append('image', obj.moduleImage, obj.moduleImage.name);
        if (obj.icon != null)
            formData.append('icon', obj.icon, obj.icon.name);
        if (obj.iconPath != null)
            formData.append('iconPath', obj.iconPath);

        return this.http.post(`${this.pathApi}addNewModule`, formData, {
            observe: 'response',
        });
    }

    getAll(): Observable<any> {
        return this.http.get(`${this.pathApi}getAll`, {
            headers: this.headers,
            observe: 'response'
        });
    }
}